import { render, staticRenderFns } from "./CCTooltip.vue?vue&type=template&id=561b1219&scoped=true&"
import script from "./CCTooltip.vue?vue&type=script&lang=ts&"
export * from "./CCTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./CCTooltip.vue?vue&type=style&index=0&id=561b1219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b1219",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VTooltip})
